import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Banners from '../../../../components/elements/Banners';
import { getAsync } from '../../../../components/helper/axiosHelper';
import LoadingAnimation from '../../../../components/LoadingAnimation';

const PressReleaseDetail = () => {
  const [apiData, setApiData] = useState([]);
  const [pageloading, setPageLoading] = useState(false);

  const { id } = useParams();
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);
  const getData = async () => {
    setPageLoading(true);
    await getAsync('CMSPressRelease/GetByIdCMSPressRelease/', { id: id })
      .then((response) => {
        setPageLoading(false);
        const result = response?.data[0];
        setApiData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* <div className="col-lg-12">
        <div className="header-wrapper" style={{ textAlign: 'center' }}>
          <h1>Press Release Detail</h1>
        </div>
        <div style={{ margin: '20px', padding: '20px' }} className="col-lg-10">
          {apiData?.map((item, index) => (
            <div key={index}>
              <div className="wrapper">
                <img
                  style={{
                    borderRadius: '20px',
                    border: '1px solid black',
                    height: '500px',
                    width: '600px'
                  }}
                  src={ `data:image/jpeg;base64,${item?.doc}`}
                  alt="img.jpg"
                />
              </div>
              <div className="content-title">
                <h2>{item?.title}</h2>
                <a className='text-red-500' target='_blank' href={item?.link}>{item?.link}</a>
                <p>{item?.publicationDate}</p>
              </div>
              <div className="content">
                <pre>{item?.newsPlace ? item?.newsPlace : 'N/A'}</pre>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div>
        <Banners />

        <section className={`h-90   py-10 xss:px-4 sm:px-16 ${isActive ? 'text-right' : 'text-left'}`}>
          <img src={`data:image/jpeg;base64,${apiData?.doc}`} className=" lg:w-1/2 rounded-3xl" alt="" />
          <h2 className="text-black text-sm font-bold mt-4 ">{isActive ? apiData?.date : apiData?.date}</h2>
          <h2 className="text-customgreen md:text-4xl text-2xl  font-bold py-6">
            {isActive ? apiData?.title : apiData?.titleEn}
          </h2>
          <h4 className="text-black md:text-2xl text-justify ">{isActive ? apiData?.contentAr : apiData?.contentEn}</h4>
        </section>
      </div>
      {pageloading && <LoadingAnimation />}
    </>
  );
};

export default PressReleaseDetail;
